import { EffectCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { playlistApi } from '../../api/swagger'
import { SnackbarSeverity } from '../../components/Context/SnackbarContext'
import { useAppSnackbar } from '../useAppSnackbar'
import useLoadingContext from '../useLoadingContext'
import { useLoadingIds } from '../useLoadingIds'

interface DeletePlaylistHookResponse {
  deletePlaylist: EffectCallback
}

export const useDeletePlaylist = (
  playlistKey?: number,
  onSuccess?: () => void
): DeletePlaylistHookResponse => {
  const { t } = useTranslation()
  const {
    handleError,
    setSnackbarMessage,
    setSnackbarSeverity,
    setSnackbarState,
  } = useAppSnackbar()

  const {
    Playlist: { deletePlaylist: deletePlaylistLoadingId },
  } = useLoadingIds()

  const defaultErrorMessage = t(
    'Playlist.UseDeletePlaylist.Actions.DeletePlaylistFailure',
    'An unknown error occurred requesting to delete Playlist.'
  )

  const deletePlaylist = async () => {
    if (!playlistKey) return

    try {
      await playlistApi.deletePlaylist({ playlistKey })
      setSnackbarMessage(
        t(
          'Playlist.UseDeletePlaylist.Actions.DeletePlaylistSuccess',
          'Playlist has successfully been deleted.'
        )
      )
      setSnackbarSeverity(SnackbarSeverity.Success)
      setSnackbarState(true)
      onSuccess?.()
    } catch (error) {
      await handleError(error, defaultErrorMessage)
    }
  }

  const { triggerFetch } = useLoadingContext({
    asyncFunction: deletePlaylist,
    loadingId: deletePlaylistLoadingId,
  })

  return { deletePlaylist: triggerFetch }
}
